import { IocScanIndicatorWebComponent } from './component/IocScanIndicatorWebComponent';
export { IocScanIndicatorWebComponent };
